import axios from "axios";
import {
    CREATE_FALL_PROTECTION,
    CREATE_FALL_PROTECTION_REQUEST,
    CREATE_FALL_PROTECTION_FAIL,
    SUBMIT_FALL_PROTECTION,
    SUBMIT_FALL_PROTECTION_REQUEST,
    SUBMIT_FALL_PROTECTION_FAIL,
    UPDATE_FALL_PROTECTION,
    UPDATE_FALL_PROTECTION_REQUEST,
    UPDATE_FALL_PROTECTION_FAIL,
    SET_FALL_PROTECTION_DRAFT,
    SET_FALL_PROTECTION_DRAFT_REQUEST,
    SET_FALL_PROTECTION_DRAFT_FAIL,
    APPROVE_FALL_PROTECTION,
    APPROVE_FALL_PROTECTION_REQUEST,
    APPROVE_FALL_PROTECTION_FAIL,
    REJECT_FALL_PROTECTION,
    REJECT_FALL_PROTECTION_REQUEST,
    REJECT_FALL_PROTECTION_FAIL,
    GET_FALL_PROTECTION,
    GET_FALL_PROTECTION_REQUEST,
    GET_FALL_PROTECTION_FAIL,
    GET_FALL_PROTECTIONS,
    GET_FALL_PROTECTIONS_REQUEST,
    GET_FALL_PROTECTIONS_FAIL,
    GET_FALL_PROTECTIONS_BY_USER,
    GET_FALL_PROTECTIONS_BY_USER_REQUEST,
    GET_FALL_PROTECTIONS_BY_USER_FAIL,
    GET_FALL_PROTECTIONS_BY_LOCATION,
    GET_FALL_PROTECTIONS_BY_LOCATION_REQUEST,
    GET_FALL_PROTECTIONS_BY_LOCATION_FAIL,
    DELETE_FALL_PROTECTION,
    DELETE_FALL_PROTECTION_REQUEST,
    DELETE_FALL_PROTECTION_FAIL,

} from "../types/fallProtectionTypes"

const token = localStorage.getItem("token:data");
export const createPlan = (fall) => async (dispatch) => {
    
    try {
        dispatch({
            type: CREATE_FALL_PROTECTION_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.post(`/api/v1/fall/plan`, fall, config);
        dispatch({
            type: CREATE_FALL_PROTECTION,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: CREATE_FALL_PROTECTION_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}

export const submitPlan = (fall) => async (dispatch) => {
    
    try {
        dispatch({
            type: SUBMIT_FALL_PROTECTION_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.post(`/api/v1/fall/plan/submit`, fall, config);
        dispatch({
            type: SUBMIT_FALL_PROTECTION,
            payload: data,
        });
        return data;
    } catch (error) {
        const errorMessage =
            error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message;
        dispatch({
            type: SUBMIT_FALL_PROTECTION_FAIL,
            payload: errorMessage,
        });
        throw new Error(errorMessage);
    }
}


export const updatePlan = (fall) => async (dispatch) => {
    
    try {
        dispatch({
            type: UPDATE_FALL_PROTECTION_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/fall/plan/${fall.id}`, fall, config);
        dispatch({
            type: UPDATE_FALL_PROTECTION,
            payload: data,
        });
        return data;
    } catch (error) {
        const errorMessage =
            error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message;
        dispatch({
            type: UPDATE_FALL_PROTECTION_FAIL,
            payload: errorMessage,
        });
        throw new Error(errorMessage);
    }
}

export const setPlanDraft = (id) => async (dispatch) => {
    
    try {
        dispatch({
            type: SET_FALL_PROTECTION_DRAFT_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/fall/plan/draft/${id}`, null, config);
        dispatch({
            type: SET_FALL_PROTECTION_DRAFT,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: SET_FALL_PROTECTION_DRAFT_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request 
                ? error.request.data.error
                : error.message,
        });
    }
}

export const approvePlan = (id) => async (dispatch) => {
    
    try {
        dispatch({
            type: APPROVE_FALL_PROTECTION_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/fall/plan/approve/${id}`, null, config);
        dispatch({
            type: APPROVE_FALL_PROTECTION,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: APPROVE_FALL_PROTECTION_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}

export const rejectPlan = (id) => async (dispatch) => {
    
    try {
        dispatch({
            type: REJECT_FALL_PROTECTION_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/fall/plan/reject/${id}`, null, config);
        dispatch({
            type: REJECT_FALL_PROTECTION,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: REJECT_FALL_PROTECTION_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}


export const getPlans = () => async (dispatch) => {
    
    try {
        dispatch({
            type: GET_FALL_PROTECTIONS_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.get(`/api/v1/fall/plans`, config);
        dispatch({
            type: GET_FALL_PROTECTIONS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_FALL_PROTECTIONS_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
                });
    }
}

export const getPlan = (id) => async (dispatch) => {
    
    try {
        dispatch({
            type: GET_FALL_PROTECTION_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.get(`/api/v1/fall/plan/${id}`, config);
        dispatch({
            type: GET_FALL_PROTECTION,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_FALL_PROTECTION_FAIL,
            payload:
                error.response && error.response.data?.error
                ? error.response.data?.error
                : error.request
                ? error.request.data?.error
                : error.message,
        });
    }
}

export const getPlansByUser = () => async (dispatch) => {
   
    try {
        dispatch({
            type: GET_FALL_PROTECTIONS_BY_USER_REQUEST
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        let { data } = await axios.get(`/api/v1/fall/myplans/user`, config);
        dispatch({
            type: GET_FALL_PROTECTIONS_BY_USER,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_FALL_PROTECTIONS_BY_USER_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}


export const getPlansByLocation = (id) => async (dispatch) => {
   
    try {
        dispatch({
            type: GET_FALL_PROTECTIONS_BY_LOCATION_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        let { data } = await axios.get(`/api/v1/fall/plans/location/${id}`, config);
        dispatch({
            type: GET_FALL_PROTECTIONS_BY_LOCATION,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_FALL_PROTECTIONS_BY_LOCATION_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}

export const deletePlan = (id) => async (dispatch) => {
    try {
        dispatch({
            type: DELETE_FALL_PROTECTION_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        await axios.delete(`/api/v1/fall/plan/${id}`, config);
        dispatch({
            type: DELETE_FALL_PROTECTION,
        });
    } catch (error) {
        dispatch({
            type: DELETE_FALL_PROTECTION_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}

